// This file is AUTOGENERATED, do not edit it manually!!!

export const imageAnnotations = {
    apply: 'Anwenden',
    back: 'Zurück zu Nachrichten',
    cancel: 'Abbrechen',
    comment: 'Kommentar',
    commented_on_image: 'hat das Bild kommentiert',
    comments: 'Kommentare',
    delete: 'Löschen',
    delete_comment: 'Diesen Kommentar löschen?',
    deleted_image: 'Bild wurde gelöscht',
    download: 'Bild herunterladen',
    edit: 'Bearbeiten',
    write_comment: 'Schreiben Sie Ihren Kommentar',
};
